import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useDialog } from '../../../hooks/use-dialog';
import { ProjectContext } from '../../../state/project-state/project-state';
import { Button } from '../../button/button';
import { InfoBox } from '../../info-box/info-box';
import { InactivateProjectDialog } from '../dialogs/inactivate-project-dialog';
import { Flex } from './styles';

const ActiveInfoBox = () => {
  const { t } = useTranslation();
  const { reloadProject } = React.useContext(ProjectContext);
  const inactivateProjectDialog = useDialog();

  const archiveButton = (
    <Button
      color="primary"
      variant="contained"
      onClick={() => {
        inactivateProjectDialog.show();
      }}
    >
      {t('projectSettings.status.inactivateButton', { ns: 'components' })}
    </Button>
  );

  const renderTitle = () => {
    return t('projectSettings.status.activeTitle', { ns: 'components' });
  };

  const renderInfoBox = () => {
    return (
      <InfoBox bottomMargin={true} color="yellow" leftIcon={{ icon: ['fad', 'check'] }}>
        <Flex>
          <div>{renderTitle()}</div>
          {archiveButton}
        </Flex>
      </InfoBox>
    );
  };

  return (
    <Component>
      {renderInfoBox()}

      {inactivateProjectDialog.render(
        <InactivateProjectDialog
          onClose={(archived) => {
            inactivateProjectDialog.hide();

            if (archived) {
              void reloadProject();
            }
          }}
        />,
      )}
    </Component>
  );
};

const Component = styled.div``;

export { ActiveInfoBox };
